import { createSlice } from '@reduxjs/toolkit';
import { formatDate } from '../../helpers/formatDate';

const initialState = {
  dates: [formatDate(new Date(), '00:00'), formatDate(new Date(), '23:59')],
};

export const filterSlice = createSlice({
  name: 'filterDates',
  initialState,
  reducers: {
    setFilterProperty: (state, action) => {
      const key = action.payload[0];
      const value = action.payload[1];

      if (value !== undefined && value !== null) {
        state[key] = value;
      } else {
        if (!(key in state)) {
          return state;
        }
        const newFilter = { ...state };
        delete newFilter[key];
        return newFilter;
      }
    },
    setFilter: (state, action) => {
      return {
        ...action.payload,
        dates: state.dates,
      };
    },
    resetFilter: (state, _) => {
      return {
        ...initialState,
        dates: state.dates,
      };
    },
  },
});

export const { setFilterProperty, setFilter, resetFilter } = filterSlice.actions;

export default filterSlice.reducer;
